export default function PageLoading() {
  return <h1>Page loading...</h1>;
}
